"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var CloseIcon = function CloseIcon(_ref) {
  var width = _ref.width,
    height = _ref.height,
    viewBox = _ref.viewBox;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.72363C0 1.17135 0.447715 0.723633 1 0.723633H15C15.5523 0.723633 16 1.17135 16 1.72363C16 2.27592 15.5523 2.72363 15 2.72363H1C0.447715 2.72363 0 2.27592 0 1.72363Z",
    fill: "#666666"
  }));
};
CloseIcon.defaultProps = {
  width: '16',
  height: '3',
  viewBox: '0 0 16 3'
};
CloseIcon.propTypes = {
  /**
   * the width of the icon
   */
  width: _propTypes["default"].string,
  /**
   * the height of the icon
   */
  height: _propTypes["default"].string,
  /**
   * the viewbox of the svg that wraps the icon
   */
  viewBox: _propTypes["default"].string
};
var _default = exports["default"] = CloseIcon;